import React from 'react';
import { Link } from 'react-router-dom';

const IconoUbicacion = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    className="w-4 h-4 shrink-0 text-red-500" aria-hidden="true">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const IconoTelefono = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    className="w-4 h-4 shrink-0 text-red-500" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.08 1.18 2 2 0 012.05 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const IconoCorreo = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    className="w-4 h-4 shrink-0 text-red-500" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const IconoWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IconoInstagram = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const ENLACES = [
  { to: '/',             label: 'Inicio' },
  { to: '/catalogo',     label: 'Catálogo' },
  { to: '/mi-cuenta',    label: 'Mi cuenta' },
  { to: '/privacidad',   label: 'Política de privacidad' },
  { to: '/terminos',     label: 'Términos y condiciones' },
  { to: '/devoluciones', label: 'Devoluciones' },
];

const CONTACTO = [
  { icono: <IconoUbicacion />, texto: 'Cra 21 #13-22, Armenia, Quindío' },
  { icono: <IconoTelefono />,  texto: '310 533 7348' },
  { icono: <IconoCorreo />,    texto: 'motollantas2024@gmail.com' },
];

const Footer = () => {
  return (
    <footer
      className="border-t border-red-900/40 text-gray-400"
      style={{ backgroundColor: 'rgba(18, 8, 8, 0.97)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* ── Columna 1: Marca y redes sociales ── */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-extrabold tracking-tight text-white">
                <em className="not-italic text-red-500">Moto</em>Llantas
              </span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-5">
              Distribuidora de repuestos para motos en Armenia, Quindío.
              Calidad y variedad al mejor precio.
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="https://wa.me/573105337348"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-red-700/50 text-red-400 hover:bg-red-700/20 hover:border-red-600 px-4 py-2 rounded-full text-xs font-semibold transition-all duration-200 w-fit"
              >
                <IconoWhatsApp />
                Escríbenos por WhatsApp
              </a>
              <a
                href="https://www.instagram.com/moto.llantas?igsh=MWFtdGUwY3V3cG9rMA=="
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-red-700/50 text-red-400 hover:bg-red-700/20 hover:border-red-600 px-4 py-2 rounded-full text-xs font-semibold transition-all duration-200 w-fit"
              >
                <IconoInstagram />
                Síguenos en Instagram
              </a>
            </div>
          </div>

          {/* ── Columna 2: Enlaces ── */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
              Enlaces
            </h3>
            <div className="flex flex-col gap-2.5">
              {ENLACES.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="text-sm text-gray-500 hover:text-red-400 transition-colors duration-200 w-fit"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* ── Columna 3: Contacto ── */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
              Contacto
            </h3>
            <div className="flex flex-col gap-3">
              {CONTACTO.map(({ icono, texto }) => (
                <div key={texto} className="flex items-start gap-2.5 text-sm text-gray-500">
                  <span className="mt-0.5">{icono}</span>
                  <span className="leading-relaxed">{texto}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Copyright ── */}
        <div className="border-t border-red-900/30 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-600">
          <span>© {new Date().getFullYear()} Moto llantas SAS. Todos los derechos reservados.</span>
          <span className="text-red-900/60">Armenia, Quindío · Colombia</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;